"use client";
import { getDatadogRum } from "@lib/monitoring/datadogHelper";
import { useFreshData } from "@store/hooks";
import { useCaptureUtmParams } from "@store/hooks/useCaptureUtm";
import { useEffect } from "react";
import { useAuth } from "@lib/auth/useAuth";
import { AUTH_ERROR_CODES } from "@lib/constants/error-codes";

// Component wrapper for all routes when all providers are loaded
export default function RootComponentWrapper({ children }) {
    const { session, isAnonymous, isLoading, signOut, signIn } = useAuth();
    useCaptureUtmParams();
    useFreshData();
    useEffect(() => {
        if (session?.error === AUTH_ERROR_CODES.REFRESH_TOKEN_FAILED) {
            signOut();
            return;
        }

        if (!isLoading && !session) {
            signIn("anonymous", { redirect: false });
        }

        // Set Datadog RUM user for anonymous sessions so we can track user sessions by CT anonymous ID
        if (isAnonymous) {
            getDatadogRum()?.setUser({
                id: session.anonymousId,
            });
        }
    }, [session, isLoading, isAnonymous, signOut]);

    return <>{children}</>;
}
